import {signOut} from 'aws-amplify/auth';

import {config} from '../config/amplify/auth';

// How long Amplify's own navigation to the broker's /logout gets before the page
// gives up waiting and leaves for '/'.
const FALLBACK_REDIRECT_MS = 3000;

// FNP-1685: sign out through the auth broker's /logout to this stage's
// redirectSignOut (the portal). Naming the URL explicitly is what stops Amplify
// throwing InvalidOriginException for a cross-origin logout target.
//
// Amplify starts the /logout navigation and resolves, so do NOT navigate at once:
// that would replace the broker redirect. It also resolves WITHOUT navigating when
// there is no OAuth session, so leave for '/' after a delay. A slow /logout may
// not have unloaded the page by then, and assigning location would cancel it, so
// the timer only acts when beforeunload never fired, i.e. nothing is navigating
// (D14c). A rejection (tokens are cleared first either way) leaves for '/' at once.
export const signOutViaBroker = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    let leaving = false;
    const onLeave = () => {
        leaving = true;
    };
    window.addEventListener('beforeunload', onLeave);
    try {
        // global: false is signOut()'s own default; the typed input requires it.
        await signOut({global: false, oauth: {redirectUrl}});
        setTimeout(() => {
            if (!leaving) {
                window.location.href = '/';
            }
        }, FALLBACK_REDIRECT_MS);
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
